import React from "react";
import { BrowserRouter, Switch, Route as RouterRoute } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { CssBaseline } from "@material-ui/core";
import AppLayout from "./AppLayout";
import Tickets from "../pages/Tickets";
import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Connections from "../pages/Connections";
import Tags from "../pages/Tags";
import Schedules from "../pages/Schedules";
import GoogleAgenda from "../pages/GoogleAgenda";
import GoogleAgendaReport from "../pages/GoogleAgendaReport";
import Settings from "../pages/Settings";
import Users from "../pages/Users";
import WpTemplates from "../pages/WpTemplates";
import Contacts from "../pages/Contacts";
import QuickAnswers from "../pages/QuickAnswers";
import Queues from "../pages/Queues";
import FollowUp from "../pages/FollowUp";

import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";

import { ThemeProvider } from "../context/Theme/ThemeContext";
import { BusinessTimezoneProvider } from "../context/BusinessTimezone/BusinessTimezoneContext";
import { GlobalAudioProvider } from "../context/GlobalAudio/GlobalAudioContext";
import RecoverPassword from "../pages/RecoverPassword";
import ResetPassword from "../pages/ResetPassword";
import Presentation from "../pages/Presentation";
import BulkMessaging from "../pages/BulkMessaging";
import BulkMessagingWizard from "../pages/BulkMessaging/BulkMessagingWizard";
import SalesFunnel from "../pages/SalesFunnel";
import Rating from "../pages/Rating";
import Avaliations from "../pages/Avaliations";
import HubConnect from "../pages/HubConnect";
import Report from "../pages/Report";
import { OpenAi } from "../pages/OpenAi";
import Automatize from "../pages/SalesFunnel/Automatize";
import { ConhecimentoIa } from "../pages/OpenAi/Conhecimento";
import { NovoAgente } from "../pages/OpenAi/NovoAgente";
import TriggerFunnels from "../pages/TriggerFunnels";
import AdminMaster from "../pages/AdminMaster";
import MasterCompanies from "../pages/AdminMaster/Companies";
import MasterPlans from "../pages/AdminMaster/Plans";
import MasterAddons from "../pages/AdminMaster/Addons";
import MasterCoupons from "../pages/AdminMaster/Coupons";
import MasterFinance from "../pages/AdminMaster/Finance";
import NewDashboard from "../pages/NewDashboard";
import EditCompany from "../pages/AdminMaster/EditCompany";
import SystemAnalysis from "../pages/AdminMaster/SystemAnalysis";
import SearchUsersByCompany from "../pages/AdminMaster/SearchUsersByCompany";
import ScheduleLogs from "../pages/AdminMaster/ScheduleLogs";
import BulkMessagingLogs from "../pages/AdminMaster/BulkMessagingLogs";
import MasterDocuments from "../pages/AdminMaster/Documents";
import CompanyDocumentation from "../pages/CompanyDocumentation";
import DeveloperDocs from "../pages/DeveloperDocs";
import Integrations from "../pages/integrations";
import Transactions from "../pages/Transactions";
import AdminAiReports from "../pages/AdminAiReports";
import WhatsAppMetrics from "../pages/WhatsAppMetrics";
import SocialComments from "../pages/SocialComments";

function Routes() {
	return (
		<BrowserRouter>
			<AuthProvider>
				<Switch>
					<Route exact path="/login" component={Login} />
					<Route exact path="/signup" component={Signup} />
					<RouterRoute exact path="/docs" component={DeveloperDocs} />
					<RouterRoute exact path="/docs/:section" component={DeveloperDocs} />
					<Route exact path="/rating/:uuid" component={Rating} />
					<Route exact path="/recoverPassword" component={RecoverPassword} />
					<Route exact path="/reset-password" component={ResetPassword} />
					<ThemeProvider>
						<CssBaseline />
						<BusinessTimezoneProvider>
						<WhatsAppsProvider>
							<GlobalAudioProvider>
							<AppLayout>
								<Route exact path="/" component={NewDashboard} isPrivate />
								<Route exact path="/novo-dashboard" component={NewDashboard} isPrivate />
								<Route
									exact
									path="/sales-funnel"
									component={SalesFunnel}
									isPrivate
								/>
								<Route
									exact
									path="/sales-funnel/automatize"
									component={Automatize}
									isPrivate
								/>

								<Route
									exact
									path="/avaliations"
									component={Avaliations}
									isPrivate
								/>

								<Route exact path="/reports" component={Report} isPrivate />
								<Route
									exact
									path="/whatsapp-metrics"
									component={WhatsAppMetrics}
									isPrivate
								/>
								<Route
									exact
									path="/admin-ai-reports"
									component={AdminAiReports}
									isPrivate
								/>

								<Route
									exact
									path="/tickets/:ticketId?"
									component={Tickets}
									isPrivate
								/>
								<Route
									exact
									path="/social-comments"
									component={SocialComments}
									isPrivate
								/>
								<Route
									exact
									path="/connections"
									component={Connections}
									isPrivate
								/>
								<Route exact path="/contacts" component={Contacts} isPrivate />
								<Route exact path="/users" component={Users} isPrivate />
								<Route
									exact
									path="/quickAnswers"
									component={QuickAnswers}
									isPrivate
								/>
								<Route exact path="/tags" component={Tags} isPrivate />
								<Route
									exact
									path="/schedules"
									component={Schedules}
									isPrivate
								/>
								<Route
									exact
									path="/google-agenda"
									component={GoogleAgenda}
									isPrivate
								/>
								<Route
									exact
									path="/google-agenda/relatorio"
									component={GoogleAgendaReport}
									isPrivate
								/>
								<Route
									exact
									path="/Templates"
									component={WpTemplates}
									isPrivate
								/>
								<Route
									exact
									path="/integrations"
									component={Integrations}
									isPrivate
								/>
								<Route
									exact
									path="/transactions"
									component={Transactions}
									isPrivate
								/>

								<Route
									exact
									path="/AgenteIa"
									component={OpenAi}
									isPrivate
								/>
								<Route
									exact
									path="/ConhecimentoIa"
									component={ConhecimentoIa}
									isPrivate
								/>
								<Route
									exact
									path="/novoAgente"
									component={NovoAgente}
									isPrivate
								/>
								<Route
									exact
									path="/triggerFunnels"
									component={TriggerFunnels}
									isPrivate
								/>
								<Route exact path="/Settings" component={Settings} isPrivate />
								{/* <Route exact path="/api" component={Api} isPrivate /> */}
								{/* <Route exact path="/apidocs" component={ApiDocs} isPrivate /> */}
								{/* <Route exact path="/apikey" component={ApiKey} isPrivate /> */}
								<Route exact path="/Queues" component={Queues} isPrivate />
								<Route exact path="/FollowUp" component={FollowUp} isPrivate />
								<Route
									exact
									path="/presentation"
									component={Presentation}
									isPrivate
								/>
								<Route
									exact
									path="/bulk-messaging/novo"
									component={BulkMessagingWizard}
									isPrivate
								/>
								<Route
									exact
									path="/bulk-messaging/:id/editar"
									component={BulkMessagingWizard}
									isPrivate
								/>
								<Route
									exact
									path="/bulk-messaging"
									component={BulkMessaging}
									isPrivate
								/>
								<Route
									exact
									path="/hub-connect"
									component={HubConnect}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master"
									component={AdminMaster}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/companies"
									component={MasterCompanies}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/plans"
									component={MasterPlans}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/addons"
									component={MasterAddons}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/coupons"
									component={MasterCoupons}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/finance"
									component={MasterFinance}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/system"
									component={SystemAnalysis}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/documents"
									component={MasterDocuments}
									isPrivate
								/>
								<Route
									exact
									path="/documentacao"
									component={CompanyDocumentation}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/companies/:id/edit"
									component={EditCompany}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/busca/usuarios-por-empresa"
									component={SearchUsersByCompany}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/agendamentos/logs"
									component={ScheduleLogs}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/agendamentos/logs/:scheduleId"
									component={ScheduleLogs}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/envio-massa/logs"
									component={BulkMessagingLogs}
									isPrivate
								/>
								<Route
									exact
									path="/admin-master/envio-massa/logs/:bulkId"
									component={BulkMessagingLogs}
									isPrivate
								/>
							</AppLayout>
							</GlobalAudioProvider>
						</WhatsAppsProvider>
						</BusinessTimezoneProvider>
					</ThemeProvider>
				</Switch>
				<ToastContainer autoClose={3000} closeOnClick draggable />
			</AuthProvider>
		</BrowserRouter>
	);
}

export default Routes;
